/**
 * Haptic feedback abstraction.
 * Uses @capacitor/haptics when available, falls back to navigator.vibrate().
 */

let Haptics = null;
let ImpactStyle = null;
let NotificationType = null;
let loaded = false;

async function load() {
  if (loaded) return;
  loaded = true;
  try {
    const mod = await import('@capacitor/haptics');
    Haptics = mod.Haptics;
    ImpactStyle = mod.ImpactStyle;
    NotificationType = mod.NotificationType;
  } catch {
    // Plugin not available
  }
}

// Start loading immediately
load();

const vibrateFallback = (ms) => {
  try {
    navigator.vibrate?.(ms);
  } catch {}
};

const IMPACT_DURATIONS = { light: 10, medium: 20, heavy: 30 };
const NOTIFICATION_DURATIONS = { success: 15, warning: 20, error: 30 };

export const haptics = {
  impact: async (style = 'light') => {
    await load();
    if (Haptics && ImpactStyle) {
      try {
        await Haptics.impact({ style: ImpactStyle[style.charAt(0).toUpperCase() + style.slice(1)] || ImpactStyle.Light });
        return;
      } catch {}
    }
    vibrateFallback(IMPACT_DURATIONS[style] || 10);
  },

  selection: async () => {
    await load();
    if (Haptics) {
      try {
        await Haptics.selectionStart();
        await Haptics.selectionChanged();
        await Haptics.selectionEnd();
        return;
      } catch {}
    }
    vibrateFallback(5);
  },

  notification: async (type = 'success') => {
    await load();
    if (Haptics && NotificationType) {
      try {
        await Haptics.notification({ type: NotificationType[type.charAt(0).toUpperCase() + type.slice(1)] || NotificationType.Success });
        return;
      } catch {}
    }
    vibrateFallback(NOTIFICATION_DURATIONS[type] || 15);
  },
};
